// extracted by mini-css-extract-plugin
export var tosLink = "_43-0";